<h1 matDialogTitle>Logged in User Details</h1>

<mat-dialog-content>
  <ng-container *ngIf="user; else elseTemplate">
    <div style="display: flex;flex-direction: row;flex-wrap: nowrap;align-content: space-between;justify-content: space-between;align-items: flex-start;">
      <div>
        <mat-card-subtitle>General Details</mat-card-subtitle>
        <table style="width: 100%;width: 100%;margin-top: 16px;margin-right: 32px;padding-right: 32px;">
          <tr>
            <th class="th-label">Name</th>
            <td class="td-value" style="text-align: right; padding-right: 16px;">{{user.userInfo.displayName}}</td>
          </tr>
          <tr>
            <th class="th-label">Email</th>
            <td class="td-value" style="text-align: right; padding-right: 16px;">{{user.userInfo.email}}</td>
          </tr>
          <tr>
            <th class="th-label">Salesperson Code</th>
            <td class="td-value" style="text-align: right; padding-right: 16px;">{{user.userInfo.salespersonCode}}</td>
          </tr>
        </table>
      </div>
      <div>
        <mat-card-subtitle>Roles</mat-card-subtitle>
        <table style="width: 100%;margin-top: 16px;">
          <tr *ngFor="let role of user.userInfo.roles">
            <td class="td-value" style="text-align: left; padding-right: 16px;">{{role.displayName}}</td>
          </tr>
        </table>
      </div>
    </div>
    <div style="display: flex;flex-direction: row;flex-wrap: nowrap;align-content: space-between;justify-content: space-between;align-items: flex-start;margin-top: 32px;">
      <div>
        <mat-card-subtitle>Stores</mat-card-subtitle>
        <table style="width: 100%;margin-top: 16px;">
          <tr *ngFor="let store of user.userInfo.stores">
            <td class="td-value" style="text-align: left; padding-right: 16px;">{{store.displayName}}</td>
          </tr>
        </table>
      </div>
      <div>
        <mat-card-subtitle>Warehouses for SOH</mat-card-subtitle>
        <table style="width: 100%;margin-top: 16px;">
          <tr *ngFor="let warehouse of user.userInfo.sohWarehouses">
            <td class="td-value" style="text-align: left; padding-right: 16px;">{{warehouse.displayName}}</td>
          </tr>
        </table>
      </div>
      <div>
        <mat-card-subtitle>Warehouses for Invoicing</mat-card-subtitle>
        <table style="width: 100%;margin-top: 16px;">
          <tr *ngFor="let warehouse of user.userInfo.invoiceWarehouses">
            <td class="td-value" style="text-align: lefy; padding-right: 16px;">{{warehouse.displayName}}</td>
          </tr>
        </table>
      </div>
    </div>
  </ng-container>
  <ng-template #elseTemplate>
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  </ng-template>

</mat-dialog-content>

<mat-dialog-actions>
  <button mat-button matDialogClose>Close</button>
</mat-dialog-actions>
